import React from 'react'

import Header from '../global/Header'
import Footer from '../global/Footer'
import headerBackgroundImage from '../../assets/images/background_image_mask__small.png'
import RequestAQuote from './RequestAQuote';
import SubHeading from '../ui/SubHeading';

import cmmcCompliancePageHeading from '../../assets/images/cmmc_compliance__page_heading.png';
import P from '../ui/P';
import CMMCIntroduction from '../ui/CMMCIntroduction';

function AIServices() {
  const backgroundStyle = {
    backgroundColor: '#131a27',
  };

  const headerBackgroundImageStyle = {
    backgroundImage: `url(${headerBackgroundImage})`,
  };

  return (
    <>
      <div style={backgroundStyle}>
        <div className="cmmc_compliance_body" data-testid="cmmc_compliance__page">
          <div className="cmmc_compliance__section" style={headerBackgroundImageStyle}>
            <Header />
            <div className="cmmc_compliance__card mb-6 mx-6" id="cmmc_compliance" data-testid="cmmc_compliance__component">
              <div className="bg-[#17243D] text-white rounded-t-lg shadow-xl p-6 w-full">
                <div className="rounded-t-lg flex items-center justify-center">
                  <SubHeading
                    text="CMMC Compliance"
                  />
                </div>
              </div>
              <div className="bottom_other_services__card bg-[#0C1320] text-white rounded-b-lg shadow-xl w-full pb-6">
                <img
                  src={cmmcCompliancePageHeading}
                  className="w-full border-b-2 border-gray-600 xs:border-b-1 sm:border-b-1"
                />
                <div className="p-6">

                  <CMMCIntroduction />

                  <P className="text-2xl">
                    At CypherTech Labs, we understand the critical importance of achieving Cybersecurity Maturity Model Certification (CMMC) compliance for businesses working with the Department of Defense (DoD). Our expert team specializes in guiding organizations through the complex landscape of CMMC requirements, ensuring your systems are secure and contract-ready. Whether you're handling Federal Contract Information (FCI) or Controlled Unclassified Information (CUI), we tailor our solutions to meet Levels 1, 2, or 3, aligning with NIST SP 800-171 and 800-172 standards. With CypherTech Labs, you gain a trusted partner committed to protecting your data and unlocking DoD opportunities.
                  </P>

                  <P className="text-2xl">
                    Our comprehensive CMMC-as-a-Service approach sets us apart. We begin with a thorough gap analysis to identify compliance shortfalls, followed by customized remediation plans that include secure cloud environments, robust encryption, and multi-factor authentication. Leveraging platforms like Azure Government and AWS GovCloud, Google Workspace , we build pre-configured, CMMC-compliant systems that streamline your path to certification. Our team also provides expertly crafted System Security Plans (SSPs) and Plans of Actions and Milestones (POA&Ms), ensuring you're prepared for self-assessments or third-party C3PAO evaluations. At CypherTech Labs, we make compliance efficient and achievable.
                  </P>
                  <P className="text-2xl">
                    Why choose CypherTech Labs? Our proven track record and deep industry expertise mean you're not just meeting DoD requirements—you're gaining a competitive edge. We offer ongoing managed services, including real-time monitoring, patch management, and annual affirmation support, to keep your compliance airtight. Our partnerships with accredited C3PAOs and leading cybersecurity providers ensure you receive top-tier guidance and tools. With CypherTech Labs, you're not navigating CMMC alone; we're with you every step, from initial assessment to final certification, minimizing risks and maximizing contract eligibility.
                  </P>
                  <P className="text-2xl">
                    CypherTech Labs delivers scalable, cost-effective solutions for businesses of all sizes, from small suppliers to large defense contractors. Our dedicated support team is ready to customize a compliance strategy that fits your unique needs, ensuring your business is secure and DoD-ready. Take control of your cybersecurity future and partner with CypherTech Labs to achieve CMMC compliance with confidence.
                  </P>
                </div>
                <RequestAQuote />
              </div>
            </div>
            <div className="w-100 footer_section">
              <Footer />
            </div>
          </div>
        </div>
      </div >
    </>
  )
}

export default AIServices
